export const parseNumberOrDefault = (
	value: unknown,
	defaultValue: number = 1, // FIXME: Improve Vitest configuration to allow imports and replace with `DEFAULT_PAGE`
	minValue: number = 1 // FIXME: Improve Vitest configuration to allow imports and replace with `MIN_PAGE`
) => {
	if (typeof value === 'string') {
		const parsedVal = parseFloat(value);
		// Only accept valid, non-NaN, >= minValue
		if (!Number.isNaN(parsedVal) && parsedVal >= minValue) {
			return Math.floor(parsedVal); // Convert to integer
		}
	}

	if (typeof value === 'number' && value >= minValue) {
		// Handle floating-point numbers by flooring them
		return Math.floor(value);
	}

	if (defaultValue < minValue) {
		return minValue;
	}

	return defaultValue;
};
